import { render, staticRenderFns } from "./EmailAlreadyVerified.vue?vue&type=template&id=50821ba4&scoped=true"
import script from "./EmailAlreadyVerified.vue?vue&type=script&lang=js"
export * from "./EmailAlreadyVerified.vue?vue&type=script&lang=js"
import style0 from "./EmailAlreadyVerified.vue?vue&type=style&index=0&id=50821ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50821ba4",
  null
  
)

export default component.exports